import * as React from "react";
const initialValue = Object.freeze({
  apiUrl: "",
  componentDefinitions: {}
});
const BrConfigurationContext = React.createContext(initialValue);
function useBrConfigurationContext() {
  return React.useContext(BrConfigurationContext);
}
export {
  BrConfigurationContext,
  initialValue,
  useBrConfigurationContext
};
//# sourceMappingURL=configuration.js.map
